import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Logo from '../Logo';

const FOOTER_LINKS = {
  'Services': [
    { label: 'ERP & CRM Agents', href: '/services/erp-crm-agents' },
    { label: 'WhatsApp Bot Flows', href: '/services/whatsapp-bots' },
    { label: 'Dashboard & Analytics', href: '/services/dashboard-analytics' },
    { label: 'Mobile App Agents', href: '/services/mobile-agents' },
    { label: 'Product Development', href: '/services/product-development' },
    { label: 'Website Development', href: '/services/website-development' },
    { label: 'AI SEO Agents', href: '/services/ai-seo' },
  ],
  'Offshore India': [
    { label: 'Offshore Outsourcing', href: '/offshore-outsourcing' },
    { label: 'Hire Developers India', href: '/hire-developers-india' },
    { label: 'IT Outsourcing India', href: '/it-outsourcing-india' },
    { label: 'Offshore Development Center', href: '/offshore-development-india' },
    { label: 'Pricing', href: '/pricing' },
  ],
  'Industries': [
    { label: 'Fintech', href: '/industries/fintech' },
    { label: 'Healthcare', href: '/industries/healthcare' },
    { label: 'E-commerce', href: '/industries/ecommerce' },
    { label: 'Manufacturing', href: '/industries/manufacturing' },
    { label: 'SaaS', href: '/industries/saas' },
    { label: 'Logistics', href: '/industries/logistics' },
  ],
  'Company': [
    { label: 'About Us', href: '/about' },
    { label: 'How It Works', href: '/how-it-works' },
    { label: 'AI Agents', href: '/ai-agents' },
    { label: 'Case Studies', href: '/client-success' },
    { label: 'Contact', href: '/contact' },
    { label: 'Sign In', href: '/login' },
  ],
};

export default function Footer() {
  return (
    <footer style={{ background: 'var(--footer-bg)', color: '#FAFAFA' }}>
      <div className="max-w-7xl mx-auto px-6 pt-16 pb-8">
        {/* Top section */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-10 mb-16">
          {/* Brand */}
          <div className="col-span-2 lg:col-span-2">
            <div className="flex items-center gap-2.5 mb-4">
              <Logo size={32} isDark={true} />
              <div>
                <span className="font-heading font-semibold text-lg">XceedAgents</span>
                <span className="text-blue-400 text-xs font-mono">.AI</span>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-zinc-400 max-w-sm">
              Hybrid AI + senior engineering teams. Tell us what you need built — our AI generates a free proposal in 60 seconds, then we ship it 60% faster.
            </p>
            <div className="flex items-center gap-3 mt-6 text-sm text-zinc-500 flex-wrap">
              <span>India HQ</span>
              <span className="w-1 h-1 bg-zinc-700 rounded-full" />
              <span>US</span>
              <span className="w-1 h-1 bg-zinc-700 rounded-full" />
              <span>UK</span>
              <span className="w-1 h-1 bg-zinc-700 rounded-full" />
              <span>EU</span>
              <span className="w-1 h-1 bg-zinc-700 rounded-full" />
              <span>APAC</span>
              <span className="w-1 h-1 bg-zinc-700 rounded-full" />
              <span>MENA</span>
            </div>
          </div>

          {/* Links */}
          {Object.entries(FOOTER_LINKS).map(([title, links]) => (
            <div key={title}>
              <h4 className="font-heading font-semibold text-sm tracking-wide mb-4 text-zinc-300">{title}</h4>
              <ul className="space-y-2.5">
                {links.map((link) => (
                  <li key={link.href}>
                    <Link
                      to={link.href}
                      className="text-sm text-zinc-500 hover:text-white transition-colors flex items-center gap-1"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom */}
        <div className="border-t border-zinc-800 pt-8 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-zinc-600">
            Xceedagents.ai is an{' '}
            <a
              href="https://xceeditsolutions.com"
              target="_blank"
              rel="noreferrer"
              className="underline hover:text-white transition-colors"
              data-testid="footer-xceedit-link"
            >
              XceedIT Solutions
            </a>{' '}
            Company&copy; {new Date().getFullYear()} All rights reserved
          </p>
          <div className="flex items-center gap-6">
            <a href="mailto:chandra@xceedagents.ai" className="text-xs text-zinc-500 hover:text-white transition-colors flex items-center gap-1" data-testid="footer-email">
              chandra@xceedagents.ai <ArrowUpRight className="w-3 h-3" />
            </a>
            <a href="tel:+919910059861" className="text-xs text-zinc-500 hover:text-white transition-colors" data-testid="footer-phone">
              +91 99100 59861
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
